<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';
import Heading from '../General/Heading.vue';
import Modal from '../General/Modal.vue';
import { useLoadingStore } from '../../stores';

const loading = useLoadingStore()

const { t } = useI18n()
</script>

<template>
    <Modal v-model="loading.isClassFinished" :static="true" class="!z-50">
        <Heading alignment="center">{{ t(TEXT.class_has_ended) }}</Heading>
        <div class="text-center my-7" v-html="t(TEXT.class_has_ended_desc)"></div>
    </Modal>
</template>